import React from 'react'

const Arrow = () => {
  return (
    <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.99995 7.57727L1.99962 13.4312L1.99962 1.86267L7.99995 7.57727Z" fill="#595A5B"/>
<path d="M1.85327 1.72329L1.99962 1.86267M1.99962 1.86267L7.99995 7.57727L1.99962 13.4312L1.99962 1.86267Z" stroke="#595A5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  )
}

export default Arrow
